import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    issue: 'El bebé se despierta al final de cada ciclo',
    without: 'Sin la guía',
    with: 'Técnica de encadenamiento de ciclos. Lista.'
  }, {
    issue: 'No sabés cómo eliminar la última toma por hábito',
    without: 'Sin la guía',
    with: 'Protocolo de reducción gradual. Paso a paso.'
  }, {
    issue: 'Semanas de progreso y de repente todo empeora',
    without: 'Sin la guía',
    with: 'Por qué pasa y qué hacer. Documentado.'
  }, {
    issue: 'El plan de 14 días no alcanza para las 12 horas',
    without: 'Sin la guía',
    with: 'Sistema de consolidación de 90 días.'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-38">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-39">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10" data-id="element-40">
          ¿Qué agrega la Guía de Autonomía Nocturna?
        </h3>

        <div className="overflow-x-auto rounded-2xl border border-navy-700 bg-navy-800/30" data-id="element-41">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-42">
            <thead data-id="element-43">
              <tr data-id="element-44">
                <th className="p-4 md:p-6 border-b border-navy-700 w-1/3" data-id="element-45"></th>
                <th className="p-4 md:p-6 border-b border-navy-700 bg-navy-900/50 text-center text-gray-400 font-medium w-1/3" data-id="element-46">
                  Sin la guía
                </th>
                <th className="p-4 md:p-6 border-b border-navy-700 bg-gold-500/10 text-center text-gold-400 font-bold w-1/3" data-id="element-47">
                  Con la guía
                </th>
              </tr>
            </thead>
            <tbody data-id="element-48">
              {rows.map((row, index) => <tr key={index} className="border-b border-navy-700/50 last:border-0 hover:bg-navy-800/50 transition-colors" data-id="element-49">
                  <td className="p-4 md:p-6 text-blue-50 font-medium" data-id="element-50">
                    {row.issue}
                  </td>
                  <td className="p-4 md:p-6 bg-navy-900/30 text-center text-gray-500" data-id="element-51">
                    <X className="w-5 h-5 mx-auto mb-1 opacity-50" data-id="element-52" />
                    <span className="text-sm" data-id="element-53">{row.without}</span>
                  </td>
                  <td className="p-4 md:p-6 bg-gold-500/5 text-center text-white" data-id="element-54">
                    <Check className="w-5 h-5 mx-auto mb-1 text-gold-400" data-id="element-55" />
                    <span className="text-sm" data-id="element-56">{row.with}</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </section>;
}